// Supported languages — order shown in switcher.
// The site is bilingual: English (source) and Finnish.
export const LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "fi", label: "Suomi",   flag: "🇫🇮" },
] as const;


export type LangCode = (typeof LANGUAGES)[number]["code"];

export const DEFAULT_LANG: LangCode = "en";
export const STORAGE_KEY = "what.lang";

export function isLangCode(v: string | null | undefined): v is LangCode {
  return !!v && LANGUAGES.some((l) => l.code === v);
}
